export default __webpack_public_path__ + "static/media/reviewPage.226f9f85.png";